import React, { useContext, useState } from "react";
import classes from "./Project.module.css";
import ProjectItem from "./projectItem/ProjectItem";
import ProjectItem2 from "./projectItem2/ProjectItem2";
import { projects } from "./projects";
import { ThemeContext } from "../../ThemeProvider";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";

const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Project = () => {
  const [toggle, setToggle] = useState(false);

  const { dark } = useContext(ThemeContext);

  const clickHandler = () => {
    setToggle((prev) => !prev);
  };

  const displayComponent = (item, index) => {
    if (index % 2 == 0) {
      return <ProjectItem item={item} />;
    } else {
      return <ProjectItem2 item={item} />;
    }
  };

  return (
    <section className={classes.project} id="project">
      <Reveal
        keyframes={customAnimation}
        triggerOnce="true"
        duration={1000}
        fraction={0.2}
      >
        <div
          className={
            dark
              ? `${classes.project__title} ${classes.title__dark}`
              : classes.project__title
          }
        >
          <h1>
            <span
              className={
                dark
                  ? `${classes.project__title__num} ${classes.project__title__num__dark}`
                  : classes.project__title__num
              }
            >
              03.
            </span>{" "}
            Some Things I've Built
          </h1>
          <div className={classes.title__line}></div>
        </div>
      </Reveal>
      <div className={classes.project__list}>
        {projects.map((item, index) => {
          if (!toggle && index < 2) {
            return displayComponent(item, index);
          } else if (toggle) {
            return displayComponent(item, index);
          }
        })}
      </div>
      <p
        className={
          dark
            ? `${classes.show__btn} ${classes.show__btn__dark}`
            : classes.show__btn
        }
        onClick={clickHandler}
      >
        {toggle ? "Show Less" : "Show More"}
      </p>
    </section>
  );
};

export default Project;
